import ContentAvatar from "@src/features/contentLibrary/ContentAvatar";
import Spinner from "@src/lib/ui/Spinner";
import { FC } from "react";
import ArrowUpRightIcon from "@src/lib/icons/18px/arrow-up-right";

type Props = {
  url?: string;
  isUploading?: boolean;
};
export const MediaPreview: FC<Props> = ({ url, isUploading = false }) => {
  return (
    <div className="flex size-14 items-center justify-center rounded-lg bg-gray-5-alpha">
      {(!url || isUploading) && <Spinner size={32} />}
      {url && !isUploading && (
        <div
          className="relative cursor-pointer"
          onClick={() => {
            window.open(url, "_blank");
          }}
        >
          <ContentAvatar
            coverImage={{
              imageUrls: {
                original: url,
              },
            }}
            size={"40px"}
            contentType={"Resource"}
            defaultBackgroundHashKey={url}
          />
          <div className="absolute top-0 right-0 size-[22px] rounded-[0_4px_0_4px] bg-gray-7-alpha">
            <ArrowUpRightIcon className="size-4" />
          </div>
        </div>
      )}
    </div>
  );
};
